import LoadingPage from './src/LoadingPage'
import _LoadingPageMobile from './src/LoadingPageMobile'

export const LoadingPageMobile = _LoadingPageMobile
export default LoadingPage
